import * as React from "react";
import { Paths } from "config/paths";
import { Flex } from "./flex";
import { IconLogo } from "../icons";

const Logo: React.FC = () => {
  return (
    <Flex as="a" href={Paths.root} align="center" css={{ fontWeight: "$bold" }}>
      <IconLogo />
      <span>campos uy</span>
    </Flex>
  );
};

export { Logo };
